import { render, staticRenderFns } from "./LeftNavBase.vue?vue&type=template&id=6636796e&scoped=true&"
import script from "./LeftNavBase.vue?vue&type=script&lang=js&"
export * from "./LeftNavBase.vue?vue&type=script&lang=js&"
import style0 from "./LeftNavBase.vue?vue&type=style&index=0&id=6636796e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6636796e",
  null
  
)

export default component.exports